import { render, staticRenderFns } from "./copy-form.vue?vue&type=template&id=80c80d38&"
import script from "./copy-form.vue?vue&type=script&lang=js&"
export * from "./copy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports